import { LazyImport, LazyModule } from 'owa-bundling';
import sendFeedbackCallback from 'owa-mail-addins/lib/utils/createSendFeedbackCallback';
import { SendFeedbackContainer } from 'owa-addins-core';
export { default as createMailComposeAdapter, } from './adapters/ComposeAdapters/ComposeAdapterCreator';
export { default as createMailReadAdapter } from './adapters/ReadAdapters/ReadAdapterCreator';
export { default as itemSupportsAddins } from './utils/ItemSupportsAddins';
export { default as runAfterNotificationSetup } from './utils/runAfterNotificationSetup';
export { default as makePinRequest } from './pinning/makePinRequest';
export { default as updateAddinOnItemNavigation } from './utils/updateAddinOnItemNavigation';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "Addins" */ './lazyIndex');
});
export var lazyHasInlineImage = new LazyImport(lazyModule, function (m) { return m.hasInlineImage; });
SendFeedbackContainer.sendFeedback = sendFeedbackCallback;
//# sourceMappingURL=index.js.map